


















































































































































































































































import { Component, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import ColorPickerComponent from "@/app/core/component/ColorPickerComponent.vue";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import WindowVue from "@/app/core/window/WindowVue";
import SeekBarComponent from "@/app/basic/cut-in/bgm/SeekBarComponent.vue";
import SimpleTabComponent from "@/app/core/component/SimpleTabComponent.vue";
import SceneLayerSelect from "@/app/basic/common/components/select/SceneLayerSelect.vue";
import SocketFacade, {
  permissionCheck
} from "@/app/core/api/app-server/SocketFacade";
import GameObjectManager from "@/app/basic/GameObjectManager";
import { TabInfo } from "@/@types/window";
import LanguageManager from "@/LanguageManager";
import TaskProcessor from "@/app/core/task/TaskProcessor";
import { Task, TaskResult } from "task";
import BackgroundTypeRadio from "@/app/basic/common/components/radio/BackgroundTypeRadio.vue";
import ImagePickerComponent from "@/app/core/component/ImagePickerComponent.vue";
import { StoreUseData } from "@/@types/store";
import { Scene, SceneAndLayer, SceneLayer } from "@/@types/room";
import InputTextureComponent from "@/app/basic/map/InputTextureComponent.vue";
import BorderStyleSelect from "@/app/basic/common/components/select/BorderStyleSelect.vue";
import TaskManager from "@/app/core/task/TaskManager";
import AddressInput from "@/app/basic/common/components/AddressInput.vue";
import TrStringInputComponent from "@/app/basic/common/components/TrStringInputComponent.vue";
import TrNumberInputComponent from "@/app/basic/common/components/TrNumberInputComponent.vue";
import TrColorPickerComponent from "@/app/basic/common/components/TrColorPickerComponent.vue";
import VueEvent from "@/app/core/decorator/VueEvent";
import EditSceneLayerChooserComponent from "@/app/basic/map/EditSceneLayerChooserComponent.vue";
import EditSceneObjectChooserComponent from "@/app/basic/map/EditSceneObjectChooserComponent.vue";
import { SceneObject } from "@/@types/gameObject";
import TrCheckboxComponent from "@/app/basic/common/components/TrCheckboxComponent.vue";

@Component({
  components: {
    TrCheckboxComponent,
    EditSceneObjectChooserComponent,
    EditSceneLayerChooserComponent,
    TrColorPickerComponent,
    TrNumberInputComponent,
    TrStringInputComponent,
    AddressInput,
    BorderStyleSelect,
    InputTextureComponent,
    ImagePickerComponent,
    BackgroundTypeRadio,
    SceneLayerSelect,
    SimpleTabComponent,
    ColorPickerComponent,
    SeekBarComponent,
    CtrlButton
  }
})
export default class EditSceneWindow extends Mixins<WindowVue<string, never>>(
  WindowVue
) {
  private isMounted: boolean = false;
  private isProcessed: boolean = false;
  private sceneId: string | null = null;
  private oldSceneId: string | null = null;
  private defaultTag: string = LanguageManager.instance.getText("type.map");

  private sceneList = GameObjectManager.instance.sceneList;
  private layerList = GameObjectManager.instance.sceneLayerList;
  private sceneAndLayerList = GameObjectManager.instance.sceneAndLayerList;
  private sceneObjectList = GameObjectManager.instance.sceneObjectList;

  private cc = SocketFacade.instance.sceneListCC();

  private sceneInfo: StoreUseData<Scene> | null = null;
  private sceneData: Scene | null = null;
  private sceneAndLayerInfoList: StoreUseData<SceneAndLayer>[] | null = null;
  private sceneObjectInfoList: StoreUseData<SceneObject>[] | null = null;
  private layerInfoList: StoreUseData<SceneLayer>[] | null = null;

  private selectedLayerId: string = "";
  private selectedSceneObjectId: string = "";

  @Watch("sceneObjectList", { deep: true })
  @Watch("selectedLayerId")
  private async onChangeSceneObjectInfoList() {
    setTimeout(async () => {
      type SceneObjectList = StoreUseData<SceneObject>[];
      const oldList: SceneObjectList = [];

      if (this.sceneObjectInfoList) {
        oldList.push(...this.sceneObjectInfoList.concat());
      }
      this.sceneObjectInfoList = this.sceneObjectList.filter(
        mo => mo.data!.layerId === this.selectedLayerId
      );

      const clearFocusList: SceneObjectList = oldList.filter(
        o => this.sceneObjectInfoList!.findIndex(so => so.id === o.id) < 0
      );
      const setFocusList: SceneObjectList = this.sceneObjectInfoList!.filter(
        so => oldList.findIndex(o => o.id === so.id) < 0
      );

      const focusFunc = async (id: string, isFocus: boolean): Promise<void> => {
        await EditSceneWindow.changeFocus(id, isFocus);
      };

      // 直列の非同期で全部実行する
      await clearFocusList
        .map(obj => () => focusFunc(obj.id!, false))
        .reduce((prev, curr) => prev.then(curr), Promise.resolve());

      // 直列の非同期で全部実行する
      await setFocusList
        .map(obj => () => focusFunc(obj.id!, true))
        .reduce((prev, curr) => prev.then(curr), Promise.resolve());
    });
  }

  @Watch("selectedLayerId")
  private async onChangeSelectedLayerId() {
    this.selectedSceneObjectId = "";
  }

  @Watch("selectedSceneObjectId")
  private async onChangeSelectedSceneObjectId(newVal: string, oldVal: string) {
    const focusFunc = async (id: string, isFocus: boolean): Promise<void> => {
      await EditSceneWindow.changeFocus(id, isFocus);
    };

    await focusFunc(oldVal, false);

    if (!this.sceneObjectInfoList) {
      await focusFunc(newVal, true);
      return;
    }

    type SceneObjectList = StoreUseData<SceneObject>[];

    const clearFocusList: SceneObjectList = this.sceneObjectInfoList.filter(
      so => so.id !== newVal
    );

    // 直列の非同期で全部実行する
    await clearFocusList
      .map(obj => () => focusFunc(obj.id!, false))
      .reduce((prev, curr) => prev.then(curr), Promise.resolve());

    if (this.sceneObjectInfoList.findIndex(so => so.id === newVal) < 0) {
      await focusFunc(newVal, true);
    }

    this.sceneObjectInfoList = null;
  }

  @Watch("windowInfo.status")
  private async onChangeWindowInfoStatus() {
    await this.focusAll(false);
    if (this.windowInfo.status === "window") {
      setTimeout(async () => {
        await this.focusAll(true);
      });
    }
  }

  @Watch("currentTabInfo.target")
  private async onChangeTabTarget() {
    if (this.currentTabInfo && this.currentTabInfo.target !== "layer") {
      await this.focusAll(false);
    } else {
      this.selectedLayerId = "";
    }
  }

  private async focusAll(isFocus: boolean) {
    const targetList: string[] = this.sceneObjectInfoList
      ? this.sceneObjectInfoList.map(so => so.id!)
      : [];
    if (this.selectedSceneObjectId) targetList.push(this.selectedSceneObjectId);

    // 直列の非同期で全部実行する
    await targetList
      .map(id => () => EditSceneWindow.changeFocus(id, isFocus))
      .reduce((prev, curr) => prev.then(curr), Promise.resolve());
  }

  private static async changeFocus(id: string, isFocus: boolean) {
    if (!id) return;
    await TaskManager.instance.ignition<
      { id: string; isFocus: boolean },
      never
    >({
      type: "change-focus-scene-object",
      owner: "Quoridorn",
      value: {
        id,
        isFocus
      }
    });
  }

  @Watch("sceneData", { deep: true })
  private async onChangeSceneData(newValue: Scene, oldValue: Scene | null) {
    if (oldValue === null) return;

    try {
      await this.cc.update(
        [this.sceneId!],
        [this.sceneData!],
        [{ continuous: true }]
      );
    } catch (err) {
      window.console.log("==========");
      window.console.log(err);
    }
  }

  private tabList: TabInfo[] = [
    { target: "map", text: "" },
    { target: "margin", text: "" },
    { target: "background", text: "" },
    { target: "layer", text: "" }
  ];
  private currentTabInfo: TabInfo | null = this.tabList[0];

  @TaskProcessor("language-change-finished")
  private async languageChangeFinished(
    task: Task<never, never>
  ): Promise<TaskResult<never> | void> {
    this.createTabInfoList();
    task.resolve();
  }

  @LifeCycle
  private async created() {
    this.createTabInfoList();
  }

  private createTabInfoList() {
    this.tabList.forEach(t => {
      t.text = this.$t(`label.${t.target}`)!.toString();
    });
  }

  @LifeCycle
  private async mounted() {
    await this.init();
    this.isMounted = true;
    this.sceneId = this.windowInfo.args!;
    this.sceneInfo = this.sceneList.filter(map => map.id === this.sceneId)[0];
    this.sceneData = this.sceneInfo.data!;

    this.oldSceneId = GameObjectManager.instance.roomData.sceneId;
    GameObjectManager.instance.roomData.sceneId = this.sceneId;

    setTimeout(() => {
      GameObjectManager.instance.isSceneEditing = true;
    });

    this.sceneAndLayerInfoList = this.sceneAndLayerList
      .filter(map => map.data!.sceneId === this.sceneId)
      .sort((m1, m2) => {
        if (m1.order < m2.order) return -1;
        if (m1.order > m2.order) return 1;
        return 0;
      });
    this.layerInfoList = this.sceneAndLayerInfoList
      .map(ml => this.layerList.filter(l => l.id === ml.data!.layerId)[0])
      .filter(l => l);

    if (this.windowInfo.status === "window") {
      // 排他チェック
      if (this.sceneInfo.exclusionOwner) {
        this.isProcessed = true;
        await this.close();
        return;
      }

      // パーミッションチェック
      if (!permissionCheck(this.sceneInfo, "edit")) {
        this.isProcessed = true;
        await this.close();
        return;
      }
    }

    // this.foreColor = sceneData.gridBorderColor;

    if (this.windowInfo.status === "window") {
      try {
        await this.cc.touchModify([this.sceneId]);
      } catch (err) {
        this.isProcessed = true;
        window.console.warn(err);
        await this.close();
      }
    }
  }

  @TaskProcessor("window-close-closing")
  private async windowCloseClosing2(
    task: Task<string, never>
  ): Promise<TaskResult<never> | void> {
    if (task.value !== this.windowInfo.key) return;
    await this.focusAll(false);
    GameObjectManager.instance.isSceneEditing = false;

    GameObjectManager.instance.roomData.sceneId =
      GameObjectManager.instance.sceneEditingUpdateSceneId || this.oldSceneId!;
    GameObjectManager.instance.sceneEditingUpdateSceneId = null;
    if (!this.isProcessed) {
      try {
        await this.cc!.releaseTouch([this.sceneId!]);
      } catch (err) {
        // nothing
      }
    }
  }

  private setHoverWindowMessage(isHover: boolean, messageType: string) {
    this.windowInfo.message = isHover
      ? LanguageManager.instance.getText(
          `${this.windowInfo.type}.message-select.${messageType}`
        )
      : "";
  }

  @VueEvent
  private onHoverLayerView(isHover: boolean) {
    this.setHoverWindowMessage(isHover, "layer-view");
  }

  @VueEvent
  private onHoverAddress(isHover: boolean) {
    this.setHoverWindowMessage(isHover, "original-address");
  }

  @VueEvent
  private onHoverOrderLayer(isHover: boolean) {
    this.setHoverWindowMessage(isHover, "layer-order");
  }

  @VueEvent
  private onHoverOrderObject(isHover: boolean) {
    this.setHoverWindowMessage(isHover, "object-order");
  }

  @VueEvent
  private onHoverLayerOrderMode(isHover: boolean, dragMode: boolean) {
    const messageType = `layer-order-mode-${dragMode ? "off" : "on"}`;
    this.setHoverWindowMessage(isHover, messageType);
  }

  @VueEvent
  private onHoverObjectOrderMode(isHover: boolean, dragMode: boolean) {
    const messageType = `object-order-mode-${dragMode ? "off" : "on"}`;
    this.setHoverWindowMessage(isHover, messageType);
  }
}
